"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AttachFile_exports = {};
__export(AttachFile_exports, {
  default: () => AttachFile_default
});
module.exports = __toCommonJS(AttachFile_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.35547 4.83984L7.33594 14.5078C7.33594 15.3932 7.64193 16.1419 8.25391 16.7539C8.87891 17.3659 9.6276 17.6719 10.5 17.6719C11.3724 17.6719 12.1211 17.3659 12.7461 16.7539C13.3711 16.1289 13.6836 15.3737 13.6836 14.4883L13.7031 8.90234C13.7031 8.75911 13.7487 8.64193 13.8398 8.55078C13.944 8.44661 14.0612 8.39453 14.1914 8.39453C14.3346 8.39453 14.4518 8.44661 14.543 8.55078C14.6471 8.64193 14.6992 8.75911 14.6992 8.90234L14.6797 14.4883C14.6797 15.0742 14.569 15.6211 14.3477 16.1289C14.1263 16.6367 13.8268 17.0794 13.4492 17.457C13.0716 17.8346 12.6289 18.1341 12.1211 18.3555C11.6133 18.5638 11.0729 18.668 10.5 18.668C9.92708 18.681 9.38672 18.5768 8.87891 18.3555C8.37109 18.1341 7.92839 17.8346 7.55078 17.457C7.17318 17.0794 6.8737 16.6367 6.65234 16.1289C6.44401 15.6341 6.33984 15.0938 6.33984 14.5078L6.35938 4.83984C6.35938 4.03255 6.64583 3.34245 7.21875 2.76953C7.80469 2.18359 8.5013 1.89062 9.30859 1.89062C10.1289 1.89062 10.8255 2.17708 11.3984 2.75C11.9714 3.32292 12.2578 4.01953 12.2578 4.83984L12.2383 14.5078C12.2383 14.9766 12.069 15.3802 11.7305 15.7188C11.3919 16.0573 10.9818 16.2266 10.5 16.2266C10.0312 16.2266 9.6276 16.0638 9.28906 15.7383C8.95052 15.3997 8.78125 14.9896 8.78125 14.5078L8.80078 6.48047C8.80078 6.35026 8.84635 6.23958 8.9375 6.14844C9.04167 6.04427 9.16536 5.99219 9.30859 5.99219C9.4388 5.99219 9.54948 6.04427 9.64062 6.14844C9.74479 6.23958 9.79688 6.35026 9.79688 6.48047L9.77734 14.5078C9.77734 14.7031 9.84896 14.8724 9.99219 15.0156C10.1354 15.1589 10.3047 15.2305 10.5 15.2305C10.6953 15.2305 10.8646 15.1589 11.0078 15.0156C11.151 14.8724 11.2227 14.7031 11.2227 14.5078L7.35547 4.83984ZM11.2227 14.5078L11.2617 4.83984C11.2617 4.29297 11.0729 3.83073 10.6953 3.45312C10.3177 3.07552 9.85547 2.88672 9.30859 2.88672C8.77474 2.88672 8.3125 3.08203 7.92188 3.47266C7.54427 3.85026 7.35547 4.30599 7.35547 4.83984L11.2227 14.5078Z",
      fill: "currentColor"
    }
  )
);
const SvgAttachFile = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var AttachFile_default = SvgAttachFile;
